module.exports = __webpack_public_path__ + "img/10.d0b10d96.jpg";